import { useTranslation } from "react-i18next";
import Col from "../../../components/element/col";
import Container from "../../../components/element/container";

export default function ShowroomExpert() {
  const { t } = useTranslation();

  return (
    <Container className="showroom-experts">
      <Col className="_col expert-heading">
        <h2 className="_label expert-title">
          <span>{t("Meet Our")}</span> {t("EXPERT")}
        </h2>
        <p className="_label expert-subtitle">
          {t("You can Call and Ask for your car value in current market")}
        </p>
      </Col>
    </Container>
  );
}
